import React from 'react'

export default function Firepit() {
	return (
		<div id="fire-pit" className="fire-pit">
			<div className="container-main w-container">
				<div className="pit-content">
					<div className="pit-text">
						<h3 className="h3 p-white">Meta&nbsp;Mates</h3>
						<p className="p1 p-white">
							We are all apes in our own world and we see metamates every day,
							everywhere in our daily life. We are firm believers in the idea
							that all of us is still present and we all deserve to express the
							way we wanted to. Let&apos;s come together as a community to find
							our metamates we could relate to and to make a difference in the
							Web 3.0 space.
						</p>
					</div>
					<div className="pit-image-wrap">
						<img
							src="assets/collections/angry.gif"
							loading="lazy"
							alt=""
							className="pit-image"
						/>
					</div>
				</div>
			</div>
			<div className="container-main margin-up w-container">
				<div className="tarot-wrap">
					<div className="name-wrap">
						<div className="text-block-3">tarot-reading.soon</div>
						<div>
							<img
								src="https://uploads-ssl.webflow.com/61850b66c37b75624b6fbe19/61866ba0326ced296dc40c51_Group%2093.svg"
								loading="lazy"
								alt=""
								className="image-6"
							/>
						</div>
					</div>
					<div className="tarot-content">
						<h3 className="h3">
							Tarot Reading
							<br />
							Coming soon
						</h3>
						<p className="p1">
							Take a Seat at the Fire Pit and have your Tarot Read ..
							<br />
							You never know what you might find out.
						</p>
						<img
							src="https://uploads-ssl.webflow.com/61850b66c37b75624b6fbe19/61850bd35ebb6d637ebd43a7_Hippies-10.png"
							loading="lazy"
							sizes="100vw"
							srcSet="https://uploads-ssl.webflow.com/61850b66c37b75624b6fbe19/61850bd35ebb6d637ebd43a7_Hippies-10-p-500.png 500w, https://uploads-ssl.webflow.com/61850b66c37b75624b6fbe19/61850bd35ebb6d637ebd43a7_Hippies-10-p-800.png 800w, https://uploads-ssl.webflow.com/61850b66c37b75624b6fbe19/61850bd35ebb6d637ebd43a7_Hippies-10.png 2001w"
							alt=""
							className="image-7 _2"
						/>
						<img
							src="https://uploads-ssl.webflow.com/61850b66c37b75624b6fbe19/61850bd26853c281b2b93da9_Hippies-07.png"
							loading="lazy"
							sizes="100vw"
							srcSet="https://uploads-ssl.webflow.com/61850b66c37b75624b6fbe19/61850bd26853c281b2b93da9_Hippies-07-p-500.png 500w, https://uploads-ssl.webflow.com/61850b66c37b75624b6fbe19/61850bd26853c281b2b93da9_Hippies-07-p-800.png 800w, https://uploads-ssl.webflow.com/61850b66c37b75624b6fbe19/61850bd26853c281b2b93da9_Hippies-07-p-1080.png 1080w, https://uploads-ssl.webflow.com/61850b66c37b75624b6fbe19/61850bd26853c281b2b93da9_Hippies-07-p-1600.png 1600w, https://uploads-ssl.webflow.com/61850b66c37b75624b6fbe19/61850bd26853c281b2b93da9_Hippies-07.png 2001w"
							alt=""
							className="image-7 _3"
						/>
						<img
							src="https://uploads-ssl.webflow.com/61850b66c37b75624b6fbe19/61850c966853c23baab941c8_robohippy%20(1).png"
							loading="lazy"
							sizes="100vw"
							srcSet="https://uploads-ssl.webflow.com/61850b66c37b75624b6fbe19/61850c966853c23baab941c8_robohippy%20(1)-p-500.png 500w, https://uploads-ssl.webflow.com/61850b66c37b75624b6fbe19/61850c966853c23baab941c8_robohippy%20(1)-p-800.png 800w, https://uploads-ssl.webflow.com/61850b66c37b75624b6fbe19/61850c966853c23baab941c8_robohippy%20(1)-p-1080.png 1080w, https://uploads-ssl.webflow.com/61850b66c37b75624b6fbe19/61850c966853c23baab941c8_robohippy%20(1)-p-1600.png 1600w, https://uploads-ssl.webflow.com/61850b66c37b75624b6fbe19/61850c966853c23baab941c8_robohippy%20(1).png 2000w"
							alt="Robohippy"
							className="image-7"
						/>
					</div>
				</div>
			</div>
		</div>
	)
}
